import React from 'react'

function SearchExercise() {
  return (
    <>
      <button  className='border-none w-[200px] h-[50px] text-[18px] font-poppins font-semibold cursor-pointer bg-black text-white'>
        <a href="#exercise"> Explore Exercises</a>
      </button>
    </>
  )
}

export default SearchExercise